var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pagamento-associar-etapas',{attrs:{"pagamentosServicos":_vm.obterPagamentosServicos(),"pagamento":_vm.pagamento},on:{"obterPagamentoAtualizado":function($event){return _vm.obterPagamentoAtualizado()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }